import { useEffect } from 'react';

export default function FrontChannelLogout() {
  useEffect(() => {
    // Safe to clear all OIDC keys — only this app exists at this origin
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('oidc.')) {
        sessionStorage.removeItem(key);
      }
    }
  }, []);

  return null;
}
